export default {
    easy: 'Easy Peasy',
    medium: 'Mostly Chill',
    hard_1: 'Read the Fine Print',
    hard_2: '',
    hard_3: '',
};
